import React from 'react';
import { Box, Typography } from '@material-ui/core';
import DoneAllRoundedIcon from '@material-ui/icons/DoneAllRounded';
import NotificationsActiveRoundedIcon from '@material-ui/icons/NotificationsActiveRounded';

const NotificationHeader = ({ onMarkAllRead, unreadCount }) => (
    <Box className="notification-page-header">
        <Box className="notification-page-header-intro">
            <Box className="notification-page-header-icon"><NotificationsActiveRoundedIcon /></Box>
            <Box>
                <Box className="notification-page-title-row">
                    <Typography component="h1" className="notification-page-title">Notifications</Typography>
                    {unreadCount > 0 && <Box component="span" className="notification-page-unread-badge">{unreadCount} unread</Box>}
                </Box>
                <Typography className="notification-page-subtitle">Product releases, announcements and important operational updates.</Typography>
            </Box>
        </Box>
        <Box className="notification-page-header-actions">
            <Box component="button" type="button" className="notification-page-mark-read-btn" onClick={onMarkAllRead} disabled={unreadCount === 0}>
                <DoneAllRoundedIcon />
                Mark all as read
            </Box>
        </Box>
    </Box>
);

export default NotificationHeader;
